var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('img',{attrs:{"src":require("@/static/image/empty-box.png"),"alt":"","srcset":""}}),_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }